export default {
  title: 'Sincronizzazione marchio — Marchi',
  subtitle:
    "Panoramica di tutti i ristoranti del gruppo e delle funzionalità sincronizzate. Solo l'amministratore dell'account può apportare modifiche.",
  alert: {
    message: 'Accesso solo amministratore',
    description:
      "Le modifiche al menu principale, ai prezzi e alle offerte possono essere effettuate solo dall'amministratore. Tutte le sedi ricevono gli aggiornamenti automaticamente.",
  },
  locations: {
    title: 'Sedi',
    description: 'Tutti i ristoranti del gruppo che condividono il menu e le impostazioni principali',
    locations_zero: '0 sedi',
    locations_one: '1 sede',
    locations_other: '{{count}} sedi',
    synced: 'Sincronizzato',
  },
  features: {
    title: 'Funzionalità sincronizzate',
    description: 'Queste funzionalità sono controllate dalle impostazioni principali',
    menus: {
      title: 'Menu principale',
      desription: 'Voci, categorie e descrizioni del menu sono sincronizzate in tutte le sedi',
    },
    smart_pricing: {
      title: 'Prezzi intelligenti',
      desription: 'Regole e adeguamenti dei prezzi sono sincronizzati in tutte le sedi',
    },
    offers: {
      title: 'Offerte e promozioni',
      desription: 'Offerte attive, sconti e promozioni sono sincronizzati in tutte le sedi',
    },
  },
};
